import "./AlarmCentralInformation.html";

import "./EditSiteAlarmCentrals/EditSiteAlarmCentralsComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import AlarmCentralInformationComponentController from "./AlarmCentralInformationComponentController";

export default class AlarmCentralInformationComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            site: "<",
        };
        this.controller = AlarmCentralInformationComponentController;
        this.templateUrl = "/App/Components/Site/Overview/AlarmCentralInformation/AlarmCentralInformation.html";
    }
}

module("mmManagePortal").component("mmSiteAlarmCentralInformation", new AlarmCentralInformationComponent());
